import React from 'react'

import {CashbackMessageProps} from '../../../types/cashback'
import {CashbackKarmaText} from './CashbackKarmaText'
import {CashbackKarmaWithInfo} from './CashbackKarmaWithInfo'

export interface CashbackKarmaProps extends CashbackMessageProps {
  onInfoClick?: (value: number) => void
}

export const CashbackKarma = ({
  value,
  variant,
  withInfoAction,
  messages,
  onInfoClick
}: CashbackKarmaProps) => {
  if (withInfoAction) {
    return (
      <CashbackKarmaWithInfo
        value={value}
        variant={variant}
        messages={messages}
        onInfoClick={onInfoClick}
      />
    )
  }

  return (
    <CashbackKarmaText value={value} variant={variant} messages={messages} />
  )
}
